import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TrustMarquee from "@/components/TrustMarquee";
import Stats from "@/components/Stats";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import Testimonials from "@/components/Testimonials";
import BookMeeting from "@/components/BookMeeting";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Navbar />
      <Hero />
      <TrustMarquee />
      <Stats />
      <Manifesto />
      <Services />
      <WhyUs />
      <Testimonials />
      <BookMeeting />
      <FAQ />
      <FinalCTA />
      <Footer />
    </main>
  );
}
